export default {
  state: {
    showOnboarding: false,
    step: 1,
    tourGuide: [],
    tourIndex: 0,
    finishedTourPage: false,
  },
  getters: {
    showOnboarding: state => state.showOnboarding,
    step: state => state.step,
    finalStep: state => state.tourGuide.reduce((count, obj) => {
      var counter = count;

      counter += obj.length;

      return counter;
    }, 0),
    tourGuide: state => state.tourGuide,
    finishedTourPage: state => state.finishedTourPage,
  },
  actions: {
    getTourGuide({ state }) {
      return state.tourGuide[state.tourIndex];
    },
    // getTourGuide({ state }) {
    //   return state.tourGuide;
    // },
    setOnboadingShow({ commit }, payload) {
      commit('SET_ONBOARDING_MODAL', payload);
    },
    setFinishedTourPage({ commit }, payload) {
      commit('SET_FINISHED_TOUR_PAGE', payload);
    },
    clearOnboardingModal({ commit }) {
      commit('CLEAR_ONBOARDING_MODAL');
    },
    clearTourGuide({ commit }) {
      commit('CLEAR_TOURGUIDE');
    },
    incrementStep({ commit }) {
      commit('INCREMENT_STEP');
    },
    incrementTourIndex({ commit }) {
      commit('INCREMENT_TOUR_INDEX');
    },
    initializeTourGuide({ commit }) {
      commit('INITIALIZE_TOUR_GUIDE');
      commit('SET_ONBOARDING_MODAL', true);
      commit('SET_FINISHED_TOUR_PAGE', false);
    },
    finalizeTourGuide({ commit }) {
      commit('CLEAR_TOURGUIDE');
      commit('SET_ONBOARDING_MODAL', false);
      commit('SET_FINISHED_TOUR_PAGE', true);
    },
  },
  mutations: {
    SET_ONBOARDING_MODAL(state, payload) {
      state.showOnboarding = payload;
    },
    SET_FINISHED_TOUR_PAGE(state, payload) {
      state.finishedTourPage = payload;
    },
    CLEAR_ONBOARDING_MODAL(state) {
      state.showOnboarding = null;
    },
    INCREMENT_STEP(state) {
      state.step += 1;
    },
    INCREMENT_TOUR_INDEX(state) {
      state.tourIndex += 1;
    },
    INITIALIZE_TOUR_GUIDE(state) {
      state.tourGuide = [
        [
          {
            target: '#serviceButton_0',
            title: 'RECLAMAÇÃO ONLINE',
            content: 'Aqui você encontra as opções relativas ao acompanhamento e criação de uma nova reclamação sobre algum produto ou serviço.',
            offset: -600,
            duration: 100,
            params: {
              placement: 'top'
            },
            redirect: 'OnlineComplaint',
            isLastInTour: false,
          }
        ],
        [
          {
            target: '#onlineComplaintButton_0',
            title: 'NOVA RECLAMAÇÃO',
            content: 'Aqui você cadastra uma nova reclamação sobre algum produto ou serviço.',
            offset: -600,
            duration: 100,
            params: {
              placement: 'top'
            },
            redirect: 'NewReclamation',
            isLastInTour: false,
          }
        ],
        [
            {
            target: '.fileInput-1',
            title: 'ANEXAR SEUS DOCUMENTOS',
            content: 'No primeiro passo você vai precisar anexar seus documentos pessoais para serem analisados.',
            offset: -600,
            duration: 100,
            params: {
              placement: 'bottom'
            },
            redirect: 'NextStep',
            isLastInTour: false,
          },
        ],
        [
          {
            target: '.complaint__title p',
            title: 'DADOS DA EMPRESA',
            content: 'Insira os dados da empresa contra a qual você deseja abrir uma reclamação.',
            offset: -600,
            duration: 100,
            params: {
              placement: window.innerWidth >= 1024 ? 'right' : 'bottom'
            },
            redirect: null,
            isLastInTour: false,
          },
          {
            target: '.companyData__services .companyData__subTitle p',
            title: 'SERVIÇO CONTRATADO',
            content: 'Selecione como ocorreu a compra ou contratação do serviço. Insira o endereço do estabelecimento ou a plataforma em caso de contratação online (Ex.: rede social, site...).',
            offset: -600,
            duration: 100,
            params: {
              placement: window.innerWidth >= 1024 ? 'right' : 'bottom'
            },
            redirect: null,
            isLastInTour: false,
          },
          {
            target: '.companyData__services__inputs--input.id-7 input',
            title: 'DESCRIÇÃO',
            content: 'Descreve de forma curta seu pedido à empresa (Ex.: quero estorno no cartão de crédito). E descreva a ocorrência com o máximo de detalhes possíveis.',
            offset: -600,
            duration: 100,
            params: {
              placement: window.innerWidth >= 1024 ? 'right' : 'top'
            },
            redirect: null,
            isLastInTour: false,
          },
          {
            target: '.fileInput__input-empty',
            title: 'ANEXAR ALGUM COMPROVANTE',
            content: 'Nesse campo você vai anexar todos os comprovantes que tiver para comprovar sua reclamação.',
            offset: -600,
            duration: 100,
            params: {
              placement: window.innerWidth >= 1024 ? 'right' : 'top'
            },
            redirect: 'NextStep',
            isLastInTour: false,
          },
        ],
        [
          {
            target: '.footerButtons__second',
            title: 'CONFIRME OS DADOS ',
            content: 'Nessa tela vamos te mostrar um resumo da sua reclamação e caso esteja tudo correto, é só confirmar.',
            offset: -600,
            duration: 100,
            params: {
              placement: 'top'
            },
            redirect: 'ComplaintGeneralInfo',
            isLastInTour: false,
          },
        ],
        [
          {
            target: '.footerButtons > button',
            title: 'TUDO CERTO!!',
            content: 'Sua reclamação foi realizada e o procon irá iniciar  as devidas providencias a respeito da sua reclamação.',
            offset: -600,
            duration: 100,
            params: {
              placement: 'top'
            },
            redirect: 'Home',
            isLastInTour: false,
          },
        ],
        [
          {
            target: '#serviceButton_0',
            title: 'RECLAMAÇÃO ONLINE',
            content: 'Aqui você encontra as opções relativas ao acompanhamento e criação de uma nova reclamação sobre algum produto ou serviço.',
            offset: -600,
            duration: 100,
            params: {
              placement: 'top'
            },
            redirect: 'OnlineComplaint',
            isLastInTour: false,
          }
        ],
        [
          {
            target: '#onlineComplaintButton_1',
            title: 'ACOMPANHE SUAS RECLAMAÇÕES',
            content: 'Você pode acompanhar as suas reclamações neste menu.',
            offset: -600,
            duration: 100,
            params: {
              placement: 'top'
            },
            redirect: 'MyComplaints',
            isLastInTour: false,
          },
        ],
        [
          {
            target: '.search__input',
            title: 'TUDO EM UM ÚNICO LUGAR',
            content: 'Aqui você tem acesso a todas reclamações em andamento e todas que já foram finalizadas.',
            offset: -600,
            duration: 100,
            params: {
              placement: window.innerWidth >= 1024 ? 'right' : 'bottom'
            },
            redirect: 'ComplaintDetails',
            isLastInTour: false,
          },
        ],
        [
          {
            target: '.updates',
            title: 'FIQUE SEMPRE ATUALIZADO',
            content: 'Aqui você acompanha as etapas da sua reclamação, audiências, solicitações do procon e propostas recebidas.',
            offset: -600,
            duration: 100,
            params: {
              placement: window.innerWidth >= 1024 ? 'right' : 'top'
            },
            redirect: 'Home',
            isLastInTour: true,
          },
        ],
      ];
    },
    CLEAR_TOURGUIDE(state) {
      state.tourGuide = [];
      state.step = 1;
      state.tourIndex = 0;
      state.showOnboarding = false;
    }
  }
};
